import request from "@/utils/request";

// 分页查询
export function queryCameraAccountPage(data) {
  return request({
    url: "/opPlantsHkAccountConfig/page",
    method: "post",
    data,
  });
}

// 查询详情
export function queryCameraAccountById(id) {
  return request({
    url: `/opPlantsHkAccountConfig/${id}`,
    method: "get",
  });
}

// 新增
export function insertCameraAccount(data) {
  return request({
    url: "/opPlantsHkAccountConfig/save",
    method: "post",
    data,
  });
}

// 修改
export function updateCameraAccount(data) {
  return request({
    url: "/opPlantsHkAccountConfig/update",
    method: "post",
    data,
  });
}

// 删除
export function deleteCameraAccount(id) {
  return request({
    url: `/opPlantsHkAccountConfig/delete/${id}`,
    method: "delete",
  });
}
